<template>
  <div class="player_controls" @click.stop>
    <div class="player_controls_content">
      <div class="player_controls_left">
        <span @click.stop="switchPlay">
          <i class="iconfont" :class="playing ? 'icon-weibiaoti-6-01' : 'icon-weibiaoti-5-01'" />
        </span>
        <span class="video_current_time">{{ currentTimeStamp }}</span>
      </div>
      <div class="player_controls_body">
        <div id="player_controls_progress" class="player_controls_progress" @click.stop="onClick">
          <div class="player_controls_bar">
            <div :class="['slider-bar', theme]" :style="{ width: `${format(value)}%` }">
              <div
                class="slider-btn"
                @touchstart.stop="onTouchStart"
                @touchmove.prevent.stop="onTouchMove"
                @touchend.stop="onTouchend"
                @touchcancel.stop="onTouchend"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="player_controls_right">
        <span class="video_duration">{{ durationTimeStamp }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {TouchMixin} from './utils';

export default {
  name: "VideoBar",
  mixins: [TouchMixin],
  props: {
    theme: String,
    playing: {
      type: Boolean
    },
    currentTimeStamp: {
      type: String,
      default: ''
    },
    durationTimeStamp: {
      type: String,
      default: ''
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    value: Number,
  },
  data () {
    return {
      controlsTimer: null
    }
  },
  created () {
    this.showPlayerControls()
  },
  methods: {
    showPlayerControls () {
      this.$emit('showPlayerControls')
    },
    switchPlay () {
      this.$emit('switchPlay')
    },
    onClick(event) {
      const rect = document.querySelector("#player_controls_progress").getBoundingClientRect();
      const value = ((event.clientX - rect.left) / rect.width) * 100;
      this.updateValue(value, true);
      this.showPlayerControls()
    },
    onTouchStart(event) {
      this.touchStart(event);
      this.startValue = this.format(this.value);
      this.$emit('movestart');
      this.showPlayerControls()
    },
    onTouchMove(event) {
      if (event.cancelable) {
        event.preventDefault();
        event.stopPropagation();
      }

      this.touchMove(event);
      const rect = document.querySelector("#player_controls_progress").getBoundingClientRect();
      const diff = (this.deltaX / rect.width) * 100;
      this.updateValue(this.startValue + diff);
      this.showPlayerControls()
      this.$emit('moveing');
    },
    onTouchend() {
      this.updateValue(this.value, true);
      this.$emit('moveend');
      this.resetTouchStatus()
      this.showPlayerControls()
    },
    updateValue(value, end) {
      const val = this.format(value)
      this.$emit('input', val)
      if (end) {
        this.$emit('change', val);
      }
    },
    format(value) {
      return Math.round(Math.max(this.min, Math.min(value, this.max)));
    }
  },
};
</script>
<style>
.player_controls {
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  z-index: 10;
  color: #fff;
  background: rgba(0,0,0,0.5);
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  box-sizing: content-box;
  .player_controls_content {
    position: relative;
    height: 50px;
    line-height: 100%;
    & .player_controls_left {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      width: 78px;
      padding-left: 10px;
      z-index: 10;
      span {
        display: flex;
        flex: 1;
        text-align: center;
        font-size: 14px;
        vertical-align: middle;
        & i {
          font-size: 24px;
        }
      }
    }
    & .player_controls_body {
      position: relative;
      height: 100%;
      line-height: normal;
      padding: 0 74px 0 98px;
      box-sizing: border-box;
      overflow: hidden;
      z-index: 1;
      & .player_controls_progress {
        position: relative;
        width: 100%;
        height: 100%;
        & .player_controls_bar {
          position: relative;
          height: 4px;
          margin-top: 23px;
          border-radius: 8px;
          background-color: rgba(255, 255, 255, 0.5);
          z-index: 1;
          & .slider-bar {
            position: relative;
            height: 100%;
            border-radius: 8px;
            background-color: #6460ff;
            &.diff {
              background-color: #d94926;
            }
            & .slider-btn {
              position: absolute;
              right: -16px;
              top: 50%;
              transform: translateY(-50%);
              width: 32px;
              height: 32px;
              &:after,
              &::after {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                display: block;
                width: 14px;
                height: 14px;
                content: ' ';
                border-radius: 14px;
                background-color: rgba(255, 255, 255, 0.75);
              }
            }
          }
        }
      }
    }
    & .player_controls_right {
      position: absolute;
      right: 18px;
      top: 50%;
      transform: translateY(-50%);
      width: 44px;
      z-index: 10;
      font-size: 14px;
      text-align: right;
    }
  }
}
</style>
